export default {

    data () {
        return {
            dynamic_fields_data: {}
        }
    },

    methods: {
        resetDynamicFieldData () {
            this.dynamic_fields.forEach(f => {
                if (f.type !== 'text') {
                    this.$set(this.dynamic_fields_data, f.id, { ...f, value: (this.employee[f.type] ?? null) })
                    return
                }

                const data = this.employee.dynamic_fields.find(d => d.dynamic_field_id === f.id)
                if (data) {
                    this.$set(this.dynamic_fields_data, f.id, { ...f, value: data.value })
                    return
                }
                this.$set(this.dynamic_fields_data, f.id, f)
            })
        }
    }

}
